/*
 * Copyright (C) 2025 Hendrik. All Rights Reserved.
 */

import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { useEffect} from 'react';
import AccountModal from './components/AccountModal';
import brandLogo from './logo.png';

// --- SVG Icons ---
const Icons = {
    Menu: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>,
    Dashboard: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>,
    Subjects: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>,
    Students: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>,
    Resources: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>,
    Schools: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18" /><path d="M5 21V7l8-4 8 4v14" /><path d="M17 21v-8H7v8" /><line x1="9" y1="9" x2="9" y2="9" /><line x1="9" y1="13" x2="9" y2="13" /><line x1="15" y1="9" x2="15" y2="9" /><line x1="15" y1="13" x2="15" y2="13" /></svg>,
    Developer: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>,
    Export: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12"></path><path d="M8 11l4 4 4-4"></path><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"></path></svg>,
    Users: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>,
    Foundation: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3 4 7v10l8 4 8-4V7z"></path><path d="m4 7 8 4 8-4"></path><path d="M12 11v10"></path></svg>,
    Settings: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M12 1v6m0 6v6m11-7h-6m-6 0H1m16.24-3.76l-4.24 4.24M7.76 16.24l-4.24 4.24m4.24-4.24l4.24-4.24m4.24 4.24l4.24 4.24"></path></svg>,
    Notes: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16v16H4z"></path><path d="M8 8h8"></path><path d="M8 12h8"></path><path d="M8 16h5"></path></svg>,
    AI: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v4"></path><path d="M12 18v4"></path><path d="m4.93 4.93 2.83 2.83"></path><path d="m16.24 16.24 2.83 2.83"></path><path d="M2 12h4"></path><path d="M18 12h4"></path><path d="m4.93 19.07 2.83-2.83"></path><path d="m16.24 7.76 2.83-2.83"></path><circle cx="12" cy="12" r="4"></circle></svg>,
    Worksheet: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 3h9l3 3v15H6z"></path><path d="M15 3v4h4"></path><path d="M9 11h6M9 15h6M9 19h4"></path></svg>,
    Lesson: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path><path d="M8 7h8"></path><path d="M8 11h8"></path><path d="M8 15h5"></path></svg>,
    Logo: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><path d="M9 15l2 2 4-4"></path></svg>,
    Collapse: () => <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6" /><path d="M21 5v14" /></svg>
};

export default function Navbar({ onLogout }) {
    const [username, setUsername] = useState(() => localStorage.getItem('username') || 'User');
    const [accountOpen, setAccountOpen] = useState(false);
    const isAdmin = localStorage.getItem('is_admin') === 'true';
    const isDeveloper = localStorage.getItem('user_role') === 'developer';
    const location = useLocation();

    // --- NEW REACTIVE EXPIRY STATE ---
    // We start as 'false' and let the useEffect find the real value
    const [isExpired, setIsExpired] = useState(false);

    useEffect(() => {
        const checkExpiry = () => {
            const expiryDate = localStorage.getItem('expiry_date');
            if (expiryDate) {
                const expired = new Date(expiryDate) < new Date();
                setIsExpired(expired);
            }
        };

        checkExpiry(); // Run once on load
        
        // Re-check every 60 seconds (keeps it live)
        const interval = setInterval(checkExpiry, 60000);
        return () => clearInterval(interval);
    }, [location.pathname]); // Re-run whenever the user changes pages
    // ---------------------------------

    const [menuOpen, setMenuOpen] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(() => localStorage.getItem('sidebar_collapsed') === 'true');

    useEffect(() => {
        document.body.classList.toggle('sidebar-collapsed', sidebarCollapsed);
        localStorage.setItem('sidebar_collapsed', String(sidebarCollapsed));

        return () => document.body.classList.remove('sidebar-collapsed');
    }, [sidebarCollapsed]);

    const handleLogoutClick = () => {
        if (window.confirm('Are you sure you want to logout?')) {
            onLogout();
        }
    };

    const toggleMenu = () => setMenuOpen(!menuOpen);
    const closeMenu = () => setMenuOpen(false);

    const NavItem = ({ to, icon: Icon, label }) => {
        const isActive = location.pathname.startsWith(to);
        return (
            <li>
                <Link to={to} className={`nav-link ${isActive ? 'active' : ''}`} onClick={closeMenu} title={label} aria-label={label}>
                    <span className="nav-icon"><Icon /></span>
                    <span className="nav-text">{label}</span>
                </Link>
            </li>
        );
    };

    return (
        <>
            {/* Top Navigation Bar */}
            <div className="main_Nav">
                <div className="nav-left">
                    <button className="hamburger-btn" onClick={toggleMenu} aria-label="Toggle menu">
                        <span className={`hamburger-icon ${menuOpen ? 'open' : ''}`}>
                            <span></span><span></span><span></span>
                        </span>
                    </button>
                    <div className="brand-container">
                        <span className="navbar-logo-badge" aria-hidden="true">
                            <span className="navbar-logo-crop"><img src={brandLogo} alt="" /></span>
                        </span>
                        <h2 className="navbar-brand">
                            Marksure
                        </h2>
                    </div>
                </div>
                <div className="nav-right">
                    <button type="button" className="user-info account-trigger" onClick={() => setAccountOpen(true)} aria-label={`Edit account for ${username}`} aria-haspopup="dialog" title="Edit name or password">
                        <span className="account-avatar" aria-hidden="true">{username.trim().split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase()}</span>
                        <span className="username">
                            <span className="account-name">{username}</span>
                            {isAdmin && <span className="badge admin">ADMIN</span>}
                            {isDeveloper && <span className="badge dev">DEV</span>}
                        </span>
                        <span className="account-edit-affordance" aria-hidden="true">
                            <svg className="account-edit-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="m16 3 5 5-12 12-6 1 1-6Z" /><path d="m14 5 5 5" /></svg>
                            <span className="account-edit-label">Edit</span>
                        </span>
                    </button>
                    <button onClick={handleLogoutClick} className="logout-btn" aria-label="Logout" title="Logout">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9 4H4v16h5M14 8l4 4-4 4M8 12h12" /></svg>
                        <span className="logout-label">Logout</span>
                    </button>
                </div>
            </div>

            {accountOpen && <AccountModal username={username} onSaved={setUsername} onClose={() => setAccountOpen(false)} />}

            {/* Sidebar Navigation */}
            <div className={`left_sidebar ${menuOpen ? 'active' : ''}`}>
                <div className="sidebar-collapse-row">
                    <button
                        type="button"
                        className="sidebar-collapse-btn"
                        onClick={() => setSidebarCollapsed(collapsed => !collapsed)}
                        aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                        title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                    >
                        <span className={`sidebar-collapse-icon ${sidebarCollapsed ? 'is-collapsed' : ''}`}><Icons.Collapse /></span>
                        <span className="sidebar-collapse-label">Collapse menu</span>
                    </button>
                </div>
                <ul className="nav-list">
                    {/* 1. DEVELOPERS ALWAYS SEE EVERYTHING */}
                    {isDeveloper ? (
                        <>
                            <NavItem to="/developer" icon={Icons.Developer} label="Developer" />
                            <NavItem to="/schools" icon={Icons.Schools} label="Schools" />
                            <NavItem to="/foundation-phase" icon={Icons.Foundation} label="Foundation Phase" />
                            <NavItem to="/ai-tools" icon={Icons.AI} label="AI Tools" />
                            <NavItem to="/worksheets" icon={Icons.Worksheet} label="Worksheet Studio" />
                            <NavItem to="/ai-tests" icon={Icons.Worksheet} label="AI Test Generator" />
                            <NavItem to="/lesson-plans" icon={Icons.Lesson} label="Lesson Plans" />
                            <NavItem to="/resources" icon={Icons.Resources} label="My Resources" />
                        </>
                    ) : (
                        /* 2. NORMAL TEACHERS CHECK FOR EXPIRY */
                        isExpired ? (
                            /* --- LOCKED STATE --- */
                            /* Only show Dashboard (Payment) and Settings */
                            <>
                                <NavItem to="/dashboard" icon={Icons.Dashboard} label="Dashboard" />
                                <div className="nav-divider">
                                    <span className="divider-label" style={{ color: '#d32f2f', fontSize: '0.8rem' }}>Access Locked</span>
                                </div>
                                <NavItem to="/settings" icon={Icons.Settings} label="Settings" />
                            </>
                        ) : (
                            /* --- ACTIVE STATE --- */
                            /* Show Everything */
                            <>
                                <NavItem to="/dashboard" icon={Icons.Dashboard} label="Dashboard" />
                                <NavItem to="/subjects" icon={Icons.Subjects} label="Subjects" />
                                <NavItem to="/export-marks" icon={Icons.Export} label="Export Marks" />
                                <NavItem to="/ai-tools" icon={Icons.AI} label="AI Tools" />
                                <NavItem to="/worksheets" icon={Icons.Worksheet} label="Worksheet Studio" />
                                <NavItem to="/ai-tests" icon={Icons.Worksheet} label="AI Test Generator" />
                                <NavItem to="/lesson-plans" icon={Icons.Lesson} label="Lesson Plans" />
                                <NavItem to="/notes" icon={Icons.Notes} label="Notes & Reminders" />
                                <NavItem to="/settings" icon={Icons.Settings} label="Settings" />
                                <NavItem to="/resources" icon={Icons.Resources} label="My Resources" />
                                {isAdmin && (
                                    <div className="nav-divider">
                                        <span className="divider-label">Admin</span>
                                        <NavItem to="/students" icon={Icons.Students} label="All Students" />
                                        <NavItem to="/users" icon={Icons.Users} label="Users Management" />
                                        <NavItem to="/foundation-phase" icon={Icons.Foundation} label="Foundation Phase" />
                                      
                                    </div>
                                )}
                            </>
                        )
                    )}
                </ul>

                <div className="sidebar-footer">
                    <p>© 2025 Marksure</p>
                    <p>Created by Hendrik Grobbelaar</p>
                </div>
            </div>

            {menuOpen && <div className="sidebar-overlay" onClick={closeMenu}></div>}
        </>
    );
}
